module.exports = __webpack_public_path__ + "assets/img/24_429_big.e74eb459.jpg";